import { CLOSE_MODAL, OPEN_MODAL } from '../constants/action-types';
export const modalReducer = (state = null, { type, payload } = {}) => {
    switch (type) {
        case OPEN_MODAL:
            return payload;
        case CLOSE_MODAL:
            return null;
        default:
            return state;
    }
};
export default modalReducer;
